var React = require('react');

function ExpandDisclosureIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.515906 6.88 V5.176 H5.09991 V0.808 H6.89991 V5.176 H11.4839 V6.88 H6.89991 V11.272 H5.09991 V6.88 H0.515906 Z","fill":"currentColor"}));
}

ExpandDisclosureIcon.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 12 12","fill":"none"};

module.exports = ExpandDisclosureIcon;

ExpandDisclosureIcon.default = ExpandDisclosureIcon;
